import React, { useState, useEffect, useRef } from "react";
import Header from "./Header";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import Person from "../assets/person.png";
import editImg from "../assets/edit_square.png";
import EyeOpen from "../assets/hidePass.png";
import EyeClose from "../assets/viewPass.png";
import {
  options_gender,
  options_blood_group,
} from "./../CommonJquery/WebsiteText";
import {
  handleEmailChange,
  handleNumbersChange,
  handleURLChange,
  handleAphabetsChange,
  handleError,
  handlePasswordChange,
  check_vaild_save,
  combiled_form_data,
  handleSuccessSession,
  calculateMaxDate,
  calculateMinJoinDate,
  calculateMaxJoinDate,
  cencelChanges,
} from "../CommonJquery/CommonJquery";
import {
  server_post_data,
  save_update_adminstaff,
  get_all_adminstaff,
  APL_LINK,
} from "../ServiceConnection/serviceconnection.js";
import { useLocation } from "react-router-dom";

function AddStaff() {
  const location = useLocation();
  const currentUrl = location.pathname.substring(1);
  const autocompleteRef = useRef(null);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editorDataMainID, setEditorDatMainID] = useState("0");
  const [editStaffData, seteditStaffData] = useState({});
  const [editOldImageData, seteditOldImageData] = useState([]);
  const [designations, setdesignations] = useState([]);
  const [dynaicimage, setDynaicimage] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [isPersonalID, setIsPersonalID] = useState(false);
  const [copyAddress, setCopyAddress] = useState(false);
  const [permanentAddress, setPermanentAddress] = useState("");
  const [temporaryAddress, setTemporaryAddress] = useState("");
  const isEditMode = location.pathname.includes("/edit_staff");

  const handleFileChangedynamic = (keyname) => (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      alert("Please select a valid image file.");
      event.target.value = "";
      return;
    }
    if (file.size > 500 * 1024) {
      alert("File size should be less than 500KB");
      event.target.value = "";
      return;
    }
    const reader = new FileReader();
    reader.onload = () =>
      setDynaicimage((prev) => ({
        ...prev,
        [keyname]: file,
        [keyname + "_show"]: reader.result,
      }));
    reader.readAsDataURL(file);
  };

  const handleSaveChangesdynamic = async () => {
    if (!check_vaild_save("addNewStaff")) return;
    setshowLoaderAdmin(true);
    const fd_from = combiled_form_data("addNewStaff", dynaicimage);
    fd_from.append("main_id", editorDataMainID);
    if (editOldImageData) fd_from.append("old_image_link", editOldImageData);
    try {
      const response = await server_post_data(save_update_adminstaff, fd_from);
      setshowLoaderAdmin(false);
      if (response.data.error) handleError(response.data.message);
      else handleSuccessSession(response.data.message, "/View_Staff");
    } catch {
      setshowLoaderAdmin(false);
      handleError("Network Error");
    }
  };

  const master_data_get = async (call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("flag", "3");
    fd.append("call_id", call_id);
    try {
      const response = await server_post_data(get_all_adminstaff, fd);
      if (response.data.error) {
        handleError(response.data.message);
        return;
      }
      const staff = response.data.message.data_staff[0] || {};
      seteditStaffData(staff);
      setdesignations(response.data.message.data_designation || []);
      if (staff.admin_image) {
        setDynaicimage({
          event_list_image_show:
            APL_LINK +
            response.data.message.data_link_image +
            staff.admin_image,
        });
        seteditOldImageData(staff.admin_image);
      }
      setEditorDatMainID(staff.primary_id || "0");
      setPermanentAddress(staff.admin_manual_adrress || "");
      setTemporaryAddress(staff.admin_temorary_adrress || "");
      setIsPersonalID(!!staff.coordinatory_no);
    } catch {
      handleError("Network Error");
    } finally {
      setshowLoaderAdmin(false);
    }
  };

  useEffect(() => {
    if (window.google?.maps?.places) {
      const input = document.getElementById("searchInput");
      if (!input) return;
      if (autocompleteRef.current)
        window.google.maps.event.clearInstanceListeners(
          autocompleteRef.current,
        );
      const ac = new window.google.maps.places.Autocomplete(input, {
        types: ["geocode"],
        componentRestrictions: { country: "in" },
      });
      autocompleteRef.current = ac;
      ac.addListener("place_changed", () => {
        const place = ac.getPlace();
        if (!place.geometry) return;
        let city = "",
          state = "",
          country = "";
        place.address_components.forEach(({ types, long_name }) => {
          if (
            types.includes("locality") ||
            types.includes("administrative_area_level_2")
          )
            city = long_name;
          if (types.includes("administrative_area_level_1")) state = long_name;
          if (types.includes("country")) country = long_name;
        });
        setPermanentAddress(place.formatted_address || "");
        if (document.getElementById("admin_city"))
          document.getElementById("admin_city").value = city;
        if (document.getElementById("admin_state"))
          document.getElementById("admin_state").value = state;
        if (document.getElementById("admin_country"))
          document.getElementById("admin_country").value = country;
      });
    }
    const parts = currentUrl.split("/");
    master_data_get(parts.length > 1 ? parts[1] : "0");
  }, [currentUrl]);

  useEffect(() => {
    if (copyAddress && permanentAddress) setTemporaryAddress(permanentAddress);
  }, [copyAddress, permanentAddress]);

  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}
      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head">
              <div className="pageNameDiv">
                <p>{isEditMode ? "Update Staff" : "Add Staff"}</p>
                <img src={GreyArrow} alt="arrow" />
              </div>
            </div>

            <div className="page_body">
              <div className="addStaffForms">
                <form id="addNewStaff">
                  <div className="row m-0 g-4">
                    {/* ── LEFT: Personal Details ── */}
                    <div className="col-xl-6 col-lg-7">
                      <div className="staffSection">
                        <div className="staffSectionHeader">
                          <h3>Personal Details</h3>
                        </div>
                        <div className="staffForm_container">
                          {/* Name + Photo */}
                          <div className="row m-0 align-items-center mb-2">
                            <div className="col-7 p-2">
                              <label className="staffLabel">
                                Full Name <span className="text-danger">*</span>
                              </label>
                              <div className="staffInputWrap">
                                <input
                                  type="text"
                                  id="admin_name"
                                  name="admin_name"
                                  placeholder="Enter full name"
                                  className="staffInput trio_mandatory"
                                  onInput={handleAphabetsChange}
                                  defaultValue={editStaffData.admin_name || ""}
                                />
                              </div>

                              <div className="staffCheckRow mt-3">
                                <input
                                  type="checkbox"
                                  id="id_checkbox"
                                  className="staffCheckbox"
                                  checked={isPersonalID}
                                  onChange={(e) =>
                                    setIsPersonalID(e.target.checked)
                                  }
                                />
                                <label
                                  htmlFor="id_checkbox"
                                  className="staffCheckLabel"
                                >
                                  Have Personal / Coordinator ID?
                                </label>
                              </div>
                              <div className="staffInputWrap mt-2">
                                {isPersonalID ? (
                                  <input
                                    type="text"
                                    name="coordinatory_no"
                                    placeholder="Coordinator ID"
                                    className="staffInput"
                                    defaultValue={
                                      editStaffData.coordinatory_no || ""
                                    }
                                  />
                                ) : (
                                  <input
                                    type="text"
                                    name="personal_identity_no"
                                    placeholder="Personal ID (Optional)"
                                    className="staffInput"
                                    defaultValue={
                                      editStaffData.personal_identity_no || ""
                                    }
                                  />
                                )}
                              </div>
                            </div>

                            {/* Photo */}
                            <div className="col-5 p-2">
                              <input
                                type="file"
                                id="event_list_image"
                                name="event_list_image"
                                accept="image/*"
                                onChange={handleFileChangedynamic(
                                  "event_list_image",
                                )}
                                hidden
                              />
                              <label
                                htmlFor="event_list_image"
                                className="photoUploadLabel"
                              >
                                {dynaicimage?.event_list_image_show ? (
                                  <div className="photoPreview">
                                    <img
                                      src={dynaicimage.event_list_image_show}
                                      alt="Preview"
                                      className="photoImg"
                                    />
                                    <div className="photoEditOverlay">
                                      <img src={editImg} alt="edit" />
                                    </div>
                                  </div>
                                ) : (
                                  <div className="photoPlaceholder">
                                    <img src={Person} alt="person" />
                                    <p>Add Photo</p>
                                    <span>Max 500KB</span>
                                  </div>
                                )}
                              </label>
                            </div>
                          </div>

                          <div className="row m-0">
                            {/* DOB */}
                            <div className="col-md-6 p-2">
                              <label className="staffLabel">
                                DOB <span className="text-danger">*</span>
                              </label>
                              <div
                                className="staffInputWrap"
                                onClick={() =>
                                  document
                                    .getElementById("admin_dob_date")
                                    .showPicker()
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="#9ca3af"
                                  strokeWidth="2"
                                  style={{ flexShrink: 0 }}
                                >
                                  <rect
                                    x="3"
                                    y="4"
                                    width="18"
                                    height="18"
                                    rx="2"
                                    ry="2"
                                  />
                                  <line x1="16" y1="2" x2="16" y2="6" />
                                  <line x1="8" y1="2" x2="8" y2="6" />
                                  <line x1="3" y1="10" x2="21" y2="10" />
                                </svg>
                                <input
                                  type="date"
                                  id="admin_dob_date"
                                  name="admin_dob_date"
                                  className="staffInput trio_mandatory"
                                  max={calculateMaxDate()}
                                  defaultValue={
                                    editStaffData.admin_dob_date || ""
                                  }
                                />
                              </div>
                            </div>
                            {/* Gender */}
                            <div className="col-md-6 p-2">
                              <label className="staffLabel">
                                Gender <span className="text-danger">*</span>
                              </label>
                              <select
                                name="admin_gender"
                                className="staffSelect trio_mandatory"
                                defaultValue={editStaffData.admin_gender || ""}
                              >
                                <option value="" disabled>
                                  Select Gender
                                </option>
                                {options_gender.map((o) => (
                                  <option key={o.value} value={o.value}>
                                    {o.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                            {/* Email */}
                            <div className="col-md-6 p-2">
                              <label className="staffLabel">
                                Email <span className="text-danger">*</span>
                              </label>
                              <div className="staffInputWrap">
                                <input
                                  type="email"
                                  name="admin_email"
                                  placeholder="Enter email"
                                  className="staffInput trio_mandatory"
                                  onInput={handleEmailChange}
                                  defaultValue={editStaffData.admin_email || ""}
                                />
                              </div>
                            </div>
                            {/* Blood Group */}
                            <div className="col-md-6 p-2">
                              <label className="staffLabel">Blood Group</label>
                              <select
                                name="admin_blood_group"
                                className="staffSelect"
                                defaultValue={
                                  editStaffData.admin_blood_group || ""
                                }
                              >
                                <option value="">Select</option>
                                {options_blood_group.map((o) => (
                                  <option key={o.value} value={o.value}>
                                    {o.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                            {/* Mobile */}
                            <div className="col-md-6 p-2">
                              <label className="staffLabel">
                                Mobile No <span className="text-danger">*</span>
                              </label>
                              <div className="staffInputWrap">
                                <input
                                  type="text"
                                  name="admin_mobile_no"
                                  placeholder="10-digit number"
                                  className="staffInput trio_mandatory"
                                  maxLength="10"
                                  onInput={handleNumbersChange}
                                  defaultValue={
                                    editStaffData.admin_mobile_no || ""
                                  }
                                />
                              </div>
                            </div>
                            {/* Alternate */}
                            <div className="col-md-6 p-2">
                              <label className="staffLabel">Alternate No</label>
                              <div className="staffInputWrap">
                                <input
                                  type="text"
                                  name="admin_other_no"
                                  placeholder="Optional"
                                  className="staffInput"
                                  maxLength="10"
                                  onInput={handleNumbersChange}
                                  defaultValue={
                                    editStaffData.admin_other_no || ""
                                  }
                                />
                              </div>
                            </div>

                            {/* Permanent Address */}
                            <div className="col-12 p-2">
                              <label className="staffLabel">
                                Permanent Address{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <div className="staffTextareaWrap">
                                <textarea
                                  id="searchInput"
                                  name="admin_manual_adrress"
                                  className="staffTextarea trio_mandatory"
                                  placeholder="Type or search address..."
                                  value={permanentAddress}
                                  onChange={(e) =>
                                    setPermanentAddress(e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            {/* Temporary Address */}
                            <div className="col-12 p-2">
                              <div className="staffCheckRow mb-2">
                                <input
                                  type="checkbox"
                                  id="adress_box"
                                  className="staffCheckbox"
                                  checked={copyAddress}
                                  onChange={(e) =>
                                    setCopyAddress(e.target.checked)
                                  }
                                />
                                <label
                                  htmlFor="adress_box"
                                  className="staffCheckLabel"
                                >
                                  Same as Permanent Address
                                </label>
                              </div>
                              <label className="staffLabel">
                                Temporary Address
                              </label>
                              <div className="staffTextareaWrap">
                                <textarea
                                  name="admin_temorary_adrress"
                                  className="staffTextarea"
                                  placeholder="Enter temporary address"
                                  value={temporaryAddress}
                                  onChange={(e) =>
                                    setTemporaryAddress(e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            {/* Social Media */}
                            <div className="col-12 p-2 mt-1">
                              <div className="socialMediaHeader">
                                <h6>
                                  Social Media{" "}
                                  <span className="optionalTag">Optional</span>
                                </h6>
                              </div>
                              <div className="staffInputWrap mt-2">
                                <input
                                  type="url"
                                  name="facebook_link"
                                  placeholder="Facebook Profile URL"
                                  className="staffInput"
                                  onInput={handleURLChange}
                                  defaultValue={
                                    editStaffData.facebook_link || ""
                                  }
                                />
                              </div>
                              <div className="staffInputWrap mt-2">
                                <input
                                  type="url"
                                  name="instragram_link"
                                  placeholder="Instagram Profile URL"
                                  className="staffInput"
                                  onInput={handleURLChange}
                                  defaultValue={
                                    editStaffData.instragram_link || ""
                                  }
                                />
                              </div>
                              <div className="staffInputWrap mt-2">
                                <input
                                  type="url"
                                  name="linkedin_link"
                                  placeholder="LinkedIn Profile URL"
                                  className="staffInput"
                                  onInput={handleURLChange}
                                  defaultValue={
                                    editStaffData.linkedin_link || ""
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ── RIGHT: Employee Details ── */}
                    <div className="col-xl-6 col-lg-5">
                      <div className="staffSection">
                        <div className="staffSectionHeader">
                          <h3>Employee Details</h3>
                        </div>
                        <div className="staffForm_container">
                          <div className="row m-0">
                            {/* Joining Date */}
                            <div className="col-12 p-2">
                              <label className="staffLabel">
                                Joining Date{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <div className="staffInputWrap">
                                <input
                                  type="date"
                                  name="admin_join_date"
                                  className="staffInput trio_mandatory"
                                  min={calculateMinJoinDate()}
                                  max={calculateMaxJoinDate()}
                                  defaultValue={
                                    editStaffData.admin_join_date || ""
                                  }
                                />
                              </div>
                            </div>
                            {/* Designation */}
                            <div className="col-12 p-2">
                              <label className="staffLabel">
                                Designation{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <select
                                name="admin_designation"
                                className="staffSelect trio_mandatory"
                              >
                                <option value="">Select Designation</option>
                                {designations.map((d) => (
                                  <option
                                    key={d.primary_id}
                                    value={d.primary_id}
                                    selected={
                                      d.primary_id ===
                                      editStaffData.admin_designation
                                    }
                                  >
                                    {d.designation_name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {!isEditMode && (
                              <>
                                {/* Create Password */}
                                <div className="col-12 p-2">
                                  <label className="staffLabel">
                                    Create Password{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div className="staffInputWrap">
                                    <input
                                      type={showPassword ? "text" : "password"}
                                      name="admin_password"
                                      placeholder="Enter password"
                                      className="staffInput trio_password trio_mandatory"
                                      onInput={handlePasswordChange}
                                    />
                                    <button
                                      type="button"
                                      className="eyeToggleBtn"
                                      onClick={() =>
                                        setShowPassword(!showPassword)
                                      }
                                    >
                                      <img
                                        src={showPassword ? EyeOpen : EyeClose}
                                        alt="toggle"
                                      />
                                    </button>
                                  </div>
                                </div>
                                {/* Confirm Password */}
                                <div className="col-12 p-2">
                                  <label className="staffLabel">
                                    Confirm Password{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div className="staffInputWrap">
                                    <input
                                      type={showPassword1 ? "text" : "password"}
                                      name="admin_confirm_password"
                                      placeholder="Confirm password"
                                      className="staffInput trio_password trio_mandatory"
                                      onInput={handlePasswordChange}
                                    />
                                    <button
                                      type="button"
                                      className="eyeToggleBtn"
                                      onClick={() =>
                                        setShowPassword1(!showPassword1)
                                      }
                                    >
                                      <img
                                        src={showPassword1 ? EyeOpen : EyeClose}
                                        alt="toggle"
                                      />
                                    </button>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                        <div className="staffFormActions">
                          <button
                            type="button"
                            className="btnStaffCancel"
                            onClick={cencelChanges}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btnStaffSave"
                            onClick={handleSaveChangesdynamic}
                          >
                            {isEditMode ? "Update Staff" : "Save Staff"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddStaff;
